import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const WishlistContext = createContext(null);
const KEY = "lnr_wishlist";

export const WishlistProvider = ({ children }) => {
  const [slugs, setSlugs] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(slugs)); }, [slugs]);

  const toggle = useCallback((slug) => {
    setSlugs((prev) => (prev.includes(slug) ? prev.filter((s) => s !== slug) : [...prev, slug]));
  }, []);
  const has = useCallback((slug) => slugs.includes(slug), [slugs]);

  return (
    <WishlistContext.Provider value={{ slugs, toggle, has, count: slugs.length }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
